import { DecimalPipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavegationPagesService } from './services/navegation-pages.service';
import { ThemeServiceService } from './services/theme-service.service';
import { MenuConfigService } from './services/menu-config.service';
import { MenuItem } from './config/menu-config';
import { routeAnimations } from './animations/route-animations';

gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  private stop$ = new Subject<void>();
  public reachedTheEnd: boolean;
  reachedTheEnd2: boolean;
  title = 'Brandon Lee';

  showNav: boolean = true;
  public enabledMenus: MenuItem[] = [];

  @ViewChild('home') home: ElementRef;
  @ViewChild('abautMe') abautMe: ElementRef;
  @ViewChild('skills') skills: ElementRef;
  @ViewChild('experience') experience: ElementRef;
  @ViewChild('projects') projects: ElementRef;
  @ViewChild('gallery') gallery: ElementRef;
  @ViewChild('contact') contact: ElementRef;

  seleccionado = 'home';

  constructor(
    private readonly themeService: ThemeServiceService,
    private readonly _navigationPages: NavegationPagesService,
    private readonly _menuConfigService: MenuConfigService,
    private decimalPipe: DecimalPipe
  ) { }
  ngAfterViewInit(): void { 
    this._navigationPages.page$.subscribe((pagina) => {
      this.scrollToSection(pagina);
    });
  }

  scrollToSection(pagina: string): void {
    const element = document.getElementById(pagina);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  
  verificarIdElemtHtml(): void {
    const sections = [
      this.home,
      this.abautMe,
      this.skills,
      this.experience,
      this.projects,
      this.gallery,
      this.contact,
    ];

   
  }

  ngOnInit(): void {
    this.loadEnabledMenus();
    this.defaultColor();
    this.defaultTheme();
    
    // Escuchar cambios en la configuración de menús
    this._menuConfigService.onConfigChange()
      .pipe(takeUntil(this.stop$))
      .subscribe(() => {
        this.loadEnabledMenus();
      });
      
    gsap.to('progress', {
      value: 100,
      scrollTrigger: {
        trigger: '.todo',
        scrub: 0.3,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (options) => {
          if (options instanceof ScrollTrigger) {
            const value = Number(
              this.decimalPipe.transform(options.progress, '1.2-2')
            );
            console.log(value);
            this.reachedTheEnd2 = value > 0.07;
            this.reachedTheEnd = value > 0.84;
            this.verificarIdElemtHtml();
          }
        },
      },
    });
    setTimeout(() => { }, 1000);
  
  }

  ngOnDestroy(): void {
    this.stop();
  }

  durante(e: any) {
    if (e.y < 30) {
      this.showNav = true;
    } else {
      this.showNav = true;
    }
    setTimeout(() => { }, 1000);

  }



  defaultColor(): void {
    this.themeService.setDefaultTheme();
  }

  defaultTheme() {
    this.themeService.setDarkTheme();
    setTimeout(() => {
      document.body.classList.add('animate-colors-transition');
    }, 500);
  }

  onClick(elem: HTMLElement) {
    this._navigationPages.seleccionado('home');
    elem.scrollIntoView({ behavior: 'smooth' });
  }


  /**
   * Carga los menús habilitados desde la configuración
   */
  private loadEnabledMenus(): void {
    this.enabledMenus = this._menuConfigService.getPrimaryMenus();
    this.logMenuStatus();
  }

  /**
   * Muestra en consola el estado actual de los menús (para debugging)
   */
  private logMenuStatus(): void {
    if (typeof console !== 'undefined') {

      
      const allMenus = ['home', 'abautMe', 'skills', 'experience', 'projects', 'gallery', 'contact'];
      allMenus.forEach(menuId => {
        const enabled = this.isMenuEnabled(menuId);
/*         console.log(`${enabled ? '✅' : '❌'} ${menuId}: ${enabled ? 'Habilitado' : 'Deshabilitado'}`);
 */      });
      
      console.groupEnd();
    }
  }

  /**
   * Verifica si un menú específico está habilitado
   */
  isMenuEnabled(menuId: string): boolean {
    return this._menuConfigService.isMenuEnabled(menuId);
  }

  /**
   * Obtiene los menús habilitados para uso en el template
   */
  getEnabledMenus(): MenuItem[] {
    return this.enabledMenus;
  }

  /**
   * Prepara la animación de transición de ruta
   */
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  onRouteActivate(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  stop(): void {
    this.stop$.next();
    this.stop$.complete();
  }
}
